import { Typography } from '@/components/ui/typography';

interface Metricprops {
  label: string;
  icon: string;
  children: React.ReactNode;
}

export function Metric({ label, icon, children }: Metricprops) {
  return (
    <div className="shadow-base flex h-[76px] min-w-[180px] shrink-0 grow flex-row items-center gap-4 rounded-lg bg-white p-4">
      <img src={icon} alt="Metric" />
      <div className="flex flex-col items-start">
        <Typography variant="subtitle1">{label}</Typography>
        {children}
      </div>
    </div>
  );
}
